import { InjectionToken } from '@angular/core';

export type BooxApiToken = {
    host: string;
    apiKey: string,
    rootPath: string,
    headerApiKey: string,
    headerSessionToken: string,
    envPath: string,
}

export type BooxApisToken = {
    [key: string]: BooxApiToken;
}

export const BOOX_APIS = new InjectionToken<BooxApisToken>('(lib-boox) BOOX_APIS',{
  providedIn : 'root',
  factory: () => ({})
});

export const BOOX_DEFAULT_API = new InjectionToken<string>('(lib-boox) BOOX_DEFAULT_API', {
  providedIn : 'root',
  factory: () => 'boox'
});
